// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"sub-title-module--subTitle--fi4rP","step":"sub-title-module--step--1mCy3"};